<template>
  <div class="reports">
    <div v-if="$store.state.pageLoaded" class="reports-listing">
      <div v-if="Object.keys($store.state.receivedData.reportsGeneralAll.list).length > 0" ref="report">
      <h2 class="md-title">
        Kumulativni izvještaj - sve predstave
      </h2>
        <md-table class="print-table">
          <md-table-row>
            <md-table-head>Datum</md-table-head>
            <md-table-head class="t-align-left">&nbsp;&nbsp;Predstava</md-table-head>
            <md-table-head class="t-align-left">Prodano</md-table-head>
            <md-table-head class="t-align-left">Rezervirano</md-table-head>
            <md-table-head class="t-align-left">Ukupno</md-table-head>
          </md-table-row>
          <md-table-row v-for="value, key in $store.state.receivedData.reportsGeneralAll.list">
            <md-table-cell>{{ getFullDate(value.start_time).date }} - {{ getFullDate(value.start_time).time }}</md-table-cell>
            <md-table-cell class="t-align-left">&nbsp;&nbsp;{{ value.title }}</md-table-cell>
            <md-table-cell class="t-align-left">{{ value.seats.sold }}</md-table-cell>
            <md-table-cell class="t-align-left">{{ value.seats.reserved }}</md-table-cell>
            <md-table-cell class="t-align-left">{{ value.seats.sum }}</md-table-cell>
          </md-table-row>
        </md-table>
          <md-button class="md-primary md-dense md-raised fixed-print-btn print-btn" v-on:click="print($refs.report)">
          Ispiši
        </md-button>
      </div>
      <div v-else class="error">
        <h3>Nažalost nema izvješća za prikaz</h3>
      </div>
    </div>
  </div>
</template>

<script>
import ReportsMixin from '../../../mixins/reports-mixin';

export default {
  name: 'ReportsGeneralAll',
  mixins: [ReportsMixin('')],
  data(){
    return{
      reportVisible: false,
    }
  },

  methods:{
    zeroed(data){
      if(parseInt(data) < 10) return `0${data}`
      return data;
    },

    getFullDate(dateReceived){
      let date = new Date(dateReceived);
      return{
        date: `${this.zeroed(date.getDate())}.${this.zeroed(date.getMonth()+1)}.${this.zeroed(date.getFullYear())}`,
        time: `${this.zeroed(date.getHours())}:${this.zeroed(date.getMinutes())}`,
      }
    },
  }
}
</script>

<style scoped lang="scss">
.reports h2{
  text-align: center;
  margin: 50px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Tickets/ReportsGeneralAll.vue